import React from 'react';
import type { SenderProps } from './interface';
export const SenderContext = React.createContext<SenderProps & { triggerSend?: () => void }>({});
